
export default {
  name: 'AppButton',
  props: {
    tag: {
      type: String,
      default: 'button'
    },
    invert: {
      type: Boolean,
      default: false
    }
  }
}
